import React from 'react';

export const Loader = () => (
  <div className="loader">
    <strong>Loading...</strong>
  </div>
);

export default Loader;
